<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách báo cáo đơn vị đã gửi lên CSDLQG</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <!--<b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree v-model="searchForm.unitId" ref="unitTree"></unit-tree>
                                </b-form-group>
                                <b-form-group :label-cols="4" :horizontal="true">
                                    <b-form-radio-group v-model="searchForm.unitTraversalOption"
                                                        name="radio-sub-component">
                                        <b-form-radio value="0">Trực thuộc đơn vị</b-form-radio>
                                        <b-form-radio value="1">Cả đơn vị con</b-form-radio>
                                        <b-form-radio value="2">Toàn bộ đơn vị cấp dưới</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startSyncDate" placeholder="--- Tất cả ---" style="width:100%"></date-picker>
                                </b-form-group>
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endSyncDate" style="width:100%" placeholder="--- Tất cả ---"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" :syncSourceType="1" ref="unitTree" class="no-padding" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Loại báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listGroupReportTypes.length > 0" :options="listGroupReportTypes"
                                             v-model="searchForm.reportTypeGroup"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             class="no-padding"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mẫu báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listReportSyncTypeFilter.length > 0" :options="listReportSyncTypeFilter"
                                             v-model="searchForm.reportTypeId"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             class="no-padding"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col md="6">
                                <b-form-group label="Loại báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listGroupReportTypes.length > 0" :options="listGroupReportTypes"
                                             v-model="searchForm.reportTypeGroup"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             class="no-padding"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mẫu báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listReportSyncTypeFilter.length > 0" :options="listReportSyncTypeFilter"
                                             v-model="searchForm.reportTypeId"
                                             placeholder="--- Tất cả ---"
                                             allowClear="true"
                                             class="no-padding"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startSyncDate" class="no-padding" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                                <b-form-group label="Ngày báo cáo từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endSyncDate" class="no-padding" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col md="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :isRowSelectable="isDataOwner"
                            dataUrl="data/reports"
                            gridName="Danh sách báo cáo"
                            ref="reportsTable">
                        <!--<template v-slot:actions v-if="isAdmin">
                            <b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(reportTypeGroup)="row">
                            {{$store.getters.getGroupReportTypeName(row.item.reportTypeGroup)}}
                        </template>
                        <template v-slot:cell(reportDate)="row">
                            {{ getReportDate(row.item) }}
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <!--<b-button v-if="authorize(['ViewReport'])" size="sm" title="xem" @click="viewReport(row.item)" variant="info">
                                    Xem
                                </b-button>-->
                                <b-button v-if="authorize(['ViewReport'])" size="sm" title="Xem" @click="viewReport(row.item, true)" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="isDataOwner(row.item) && isAdmin" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListSyncedAssets',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    reportTypeGroup: null,
                    reportTypeId: null,
                    startDate: null,
                    endDate: new Date().formatDate(),
                    startSyncDate: null, //new Date().firstDayOfMonth().formatDate(),
                    endSyncDate: new Date().formatDate(),
                    unitId: this.getUnitTreeIdCache(this.getSyncSourceTypeCache()),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncSourceType: this.getSyncSourceTypeCache(),
                },
                pathDetail: null,
                gridOptions: {
                    fields: [
                        { key: 'reportTypeGroup', label: 'Loại báo cáo', sortable: true, sortDirection: 'asc' },
                        { key: 'reportTypeName', label: 'Mẫu báo cáo', sortable: true, sortDirection: 'asc' },
                        { key: 'reportedUnitName', label: 'Tên đơn vị', sortable: true, sortDirection: 'asc', tdAttr: (key, value, item) => ({ title: item.reportedUnitFullName }) },
                        { key: 'assetTypeGroupName', label: 'Nhóm tài sản lớn', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true, sortDirection: 'asc' },
                        { key: 'reportDate', label: 'Ngày báo cáo', sortable: false },
                    ],
                    sortBy: 'Id',
                    sortDesc: true
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            ...mapState({
                listReportSyncTypes: (state, getters) => state.common.listReportSyncTypes,
                listGroupReportTypes: (state, getters) => state.common.listGroupReportTypes,
            }),
            listReportSyncTypeFilter() {
                if (this.searchForm.reportTypeGroup) {
                    var group = this.listGroupReportTypes[this.searchForm.reportTypeGroup - 1];
                    return this.listReportSyncTypes.filter(x => group.reportTypeIds.indexOf(x.id) != -1);
                } else {
                    return this.listReportSyncTypes;
                }
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId || 1;
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.reportsTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.reportsTable.refresh();
            },
            isDataOwner(row) {
                return this.authorize(['ManageReport'], row.reportedUnitId);
            },
            viewReport(data, oracleBI) {
                var jsonParameter = {
                    reportId: data.id,
                    userId: this.$store.state.identity.userId
                };

                //var queryString = 'reportId=' + data.id;
                var reportSyncType = this.$store.getters.getReportSyncType(data.reportTypeId);

                switch (reportSyncType.periodType) {
                    case 1:
                        //queryString += `&reportDate=${formatDate(data.reportEndDate, 'YYYY-MM-DD')}`;
                        jsonParameter.reportDate = formatDate(data.reportEndDate, 'YYYY-MM-DD');
                        break; // báo cáo theo ngày
                    case 2:
                        //queryString += `&reportStartDate=${formatDate(data.reportStartDate, 'YYYY-MM-DD')}&reportEndDate=${formatDate(data.reportEndDate, 'YYYY-MM-DD')}`;
                        jsonParameter.reportStartDate = formatDate(data.reportStartDate, 'YYYY-MM-DD');
                        jsonParameter.reportEndDate = formatDate(data.reportEndDate, 'YYYY-MM-DD');
                        break; // báo cáo theo khoảng ngày
                    case 3:
                        //queryString += `&reportYear=${data.reportYear}`;
                        jsonParameter.reportYear = data.reportYear;
                        break; // báo cáo theo năm
                }

                //if (reportSyncType.unitTree) {
                //    queryString += `&unitId=${data.reportedUnitId}`;
                //}

                if (reportSyncType.assetTypeGroupId) {
                    //queryString += `&assetTypeGroupId=[${data.assetTypeGroupId || ''}]`;
                    //if (reportSyncType.assetTypeLevel) {
                    //    if (reportSyncType.assetTypeGroupId == 3) {
                    //        queryString += `&assetTypeLevel=${data.assetTypeLevel || ''}`;
                    //    }
                    //    else {
                    //        queryString += `&assetTypeLevel=5`;
                    //    }
                    //}
                    jsonParameter.assetTypeGroupId = data.assetTypeGroupId ? [data.assetTypeGroupId] : [];
                }

                if (reportSyncType.handlingType) {
                    //queryString += `&handlingType=${data.handlingType || ''}`;
                    jsonParameter.handlingType = data.handlingType;
                }

                if (reportSyncType.administrativeLevel) {
                    //queryString += `&administrativeLevel=${data.administrativeLevel}&regionId=${data.regionId}`;
                    jsonParameter.administrativeLevel = data.administrativeLevel;
                    jsonParameter.regionId = data.regionId;
                }

                if (reportSyncType.assetSource) {
                    //queryString += `&assetSourceId=${data.assetSourceId || ''}`;
                    jsonParameter.assetSourceId = data.assetSourceId ? [data.assetSourceId] : [];
                    if (reportSyncType.assetTypeLevel) {
                        //queryString += `&assetTypeLevel=${data.assetTypeLevel || ''}`;
                        jsonParameter.assetTypeLevel = data.assetTypeLevel;
                    }
                }


                if (reportSyncType.assetTypeLevel) {
                    //queryString += `&assetTypeLevel=${data.assetTypeLevel || 5}`;
                    jsonParameter.assetTypeLevel = data.assetTypeLevel || 5;
                }

                if (reportSyncType.unitLevel) {
                    //queryString += `&unitLevel=${data.unitLevel || 5}`;
                    jsonParameter.unitLevel = data.unitLevel || 5;
                }

                if (reportSyncType.decisionNumber) {
                    //queryString += `&decisionNumber=${data.decisionNumber || ''}`;
                    jsonParameter.decisionNumber = data.decisionNumber;
                }

                //queryString += `&userid=${this.$store.state.identity.userId}`;

                //var jsonParameter = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

                if (this.$services.USE_ORACLE_BI) {
                    window.open(this.$services.getOracleBIPUrl(reportSyncType.code, reportSyncType.code.substr(reportSyncType.code.indexOf('/') + 1), jsonParameter))
                } else {
                    window.open(`${this.$services.REPORT_END_POINT}${reportSyncType.code}.aspx?parameter=${encodeURI(JSON.stringify(jsonParameter))}`);
                }
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa báo cáo này?')) {
                    this.$services.delete(`data/reports/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa báo cáo thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.reportsTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các báo cáo này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/reports?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các báo cáo thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn báo cáo cần xóa');
                }
            },
            getReportDate(report) {
                var reportType = this.$store.getters.getReportSyncType(report.reportTypeId);
                var format = defaultDisplayFormatDate;
                switch (reportType.periodType) {
                    case 1: return formatDate(report.reportEndDate, format);
                    case 2: return `${formatDate(report.reportStartDate, format)} - ${formatDate(report.reportEndDate, format)}`;
                    case 3: return report.reportYear ? `31/12/${report.reportYear}` : '';
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
